import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilChispasHESP() {
  const [campo4HESP, setCampo4HESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [campo3HESP, setCampo3HESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [campo2HESP, setCampo2HESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [campo1HESP, setCampo1HESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 44,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);
    populateCampo4HESP(data);
    populateCampo3HESP(data);
    populateCampo2HESP(data);
    populateCampo1HESP(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCampo4HESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Chispas Campo 4 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCampo4HESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCampo3HESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Chispas Campo 3 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCampo3HESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCampo2HESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Chispas Campo 2 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCampo2HESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCampo1HESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Chispas Campo 1 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCampo1HESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Chispas HESP"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Chispas Campo 4 HESP --------------------------------------- */}
            <Chart.Line
              name="Chispas Campo 4 HESP"
              data={campo4HESP.value}
              yAxis={0}
            />
            {/** -------------------------------- Chispas Campo 3 HESP --------------------------------------- */}
            <Chart.Line
              name="Chispas Campo 3 HESP"
              data={campo3HESP.value}
              yAxis={0}
            />
            {/** -------------------------------- Chispas Campo 2 HESP --------------------------------------- */}
            <Chart.Line
              name="Chispas Campo 2 HESP"
              data={campo2HESP.value}
              yAxis={0}
            />
            {/** -------------------------------- Chispas Campo 1 HESP --------------------------------------- */}
            <Chart.Line
              name="Chispas Campo 1 HESP"
              data={campo1HESP.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={campo4HESP.fecha} />

            <Chart.YAxis
              labelSuffix=""
              title="Chispas, -"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
